import React from 'react';

const FooterLogo = (props) => {
    const {url, imgSrc} = props;
    return (
        <ul className="logo-container">
            <li className="logo-inner-container">
              <a
                className="logo-redirection-link"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="logo-image"
                  aria-label="Opens in a new window"
                  src={imgSrc}
                  alt="Vrbo"
                  width="100%"
                  loading="lazy"
                />
              </a>
            </li>
        </ul>
    );
};

export default FooterLogo;
